<template>
  <PreloaderComponent v-if="loading" />
  <div v-if="!loading" class="ra">
    <div class="ra__title" v-html="contract.header.head"></div>
    <!--    <div v-for="(subtitle, key) in contract.header.subtitle" :key="key">-->
    <!--      <a target="_blank" v-if="subtitle.url !== false" :href="subtitle.url">{{ subtitle.text }}</a>-->
    <!--      <p v-if="subtitle.url === false">{{ subtitle.text }}</p>-->
    <!--    </div>-->
    <div v-if="contract.header.info.strategy" class="ra__strategyTitle">
      {{ contract.header.info.strategy.title }} - {{ contract.header.info.strategy.value }}
    </div>
    <div class="ra__subtitle">Сведения о выкупных суммах</div>
    <div v-if="contract.redemption_amounts && contract.pt !== 'cred'" class="ra__accardion">
      <RaComponent
        v-if="visible.ra"
        :ra="raData"
        :project_visible="0"
        :project_state="0"
      />
    </div>
    <MakcButtonComponent @click="short_version = !short_version" class="accardion-btn">
      {{ short_version ? "Раскрыть" : "Свернуть" }}
    </MakcButtonComponent>
    <div class="ra__check">
      <MakcButtonComponent class="primary ra-btn" @click="next">ОК</MakcButtonComponent>
      <div class="ra__check-input">
        <input
          type="checkbox"
          name="acquainted"
          v-model="check"
        >
        <span>С таблицей выкупных сумм ознакомлен(а)</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import RaComponent from "@/profile/components/RaComponentNew.vue";
import MakcButtonComponent from "@/profile/components/UI/MakcButtonComponent";
import PreloaderComponent from "@/profile/components/PreloaderComponent.vue";
import {url} from "@/profile/composables/url";

export default {
  // eslint-disable-next-line
  components: {
    RaComponent,
    PreloaderComponent,
    MakcButtonComponent
  },
  name: "RedemptionAmountsView",
  props: ["id"],
  data: () => {
    return {
      contract: {
        pt: "cred"
      },
      short_version: false,
      check: true,
      names: {},
      visible: {
        ra: 1
      },
      blocks: {
        ra: 1
      },
      loading: true
    };
  },
  computed: {
    raData() {
      return this.short_version ?
        this.contract.redemption_amounts.data.slice(0, 3) :
        this.contract.redemption_amounts.data;
    }
  },
  created() {
    // загружаем данные, когда представление создано
    // и данные реактивно отслеживаются
    this.fetchData();
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    $route: "fetchData"
  },
  methods: {
    next() {
      if (this.check) {
        this.$myApp.ra.set(true);
        this.$router.push({ name: "termination", params: { id: this.id } });
      } else {
        alert("Подтвердите ознакомление");
      }
    },
    fetchData() {
      let params = {
        command: "contract_ra",
        contract_id: this.id,
        token: this.$myApp.token.get()
      };
      let $this = this;
      axios
        .post(url, {
          params: params
        })
        .then(function(response) {
          let data = response.data;
          if (data.state === "ERR") {
            if (data.msg_no == 3) {
              $this.$router.push({ name: "login" });
            }
            $this.errors = [];
            $this.errors.push(data.msg_text);
          }
          if (data.state === "OK") {
            if (data.menu) {
              $this.$myApp.menu.set(data.menu);
            }
            $this.contract = data.contract;
            $this.visible.indexing_content = data.contract.project && data.contract.project.state ? 1 : 0;
            $this.loading = false;
            $this.$forceUpdate();
          }
        })
        .catch(function(error) {
          console.log(error);
          $this.errors = [];
          $this.errors.push("Возникла ошибка, попробуйте позже");
          $this.loading = false;
        });
    }
  }
};
</script>

<style>
</style>
